import { render, staticRenderFns } from "./settlement-purchase-summary.vue?vue&type=template&id=78c5fc96&scoped=true"
import script from "./settlement-purchase-summary.vue?vue&type=script&lang=js"
export * from "./settlement-purchase-summary.vue?vue&type=script&lang=js"
import style0 from "./settlement-purchase-summary.vue?vue&type=style&index=0&id=78c5fc96&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78c5fc96",
  null
  
)

export default component.exports